export default function deviceFingerprint(state = {}, action) {
  if (action.type === 'UPDATE_DEVICE_FINGERPRINT') {
    return { ...state, fingerprint: action.payload }
  }

  return state
}
